import React, { useContext, useEffect, useState } from 'react';
import Header from "src/components/common/Header";
import ProjectForm from "src/components/project/ProjectForm";
import { getSingleProjects } from "src/store/project";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { MenuContext } from 'src/context/MenuContext';
import Menu from 'src/components/common/Menu';
import ScrollTop from 'src/components/common/ScrollTop';
import CustomLoader from 'src/components/common/CustomLoader';

export default function EditInput() {

    const { id } = useParams();
    const dispatch = useDispatch();
    const containerStyle = { width: "90%", margin: "0 auto" };
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(getSingleProjects(id)).then((res) => {
            if (res.payload) {
                setLoading(false);
            }
            if(res.error) {
                alert(res.error.message);
            }
        });
    }, []);

    const clickProjectListBtn = () => {
        navigate('/projectList');
    }

    const { visibleMenu } = useContext(MenuContext);
    return (
        <>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
                <Header sx={{ mb: 500 }} />
                <section className="container-fluid contents-top user_input">
                    <div className="text-right">
                        <button type="button" className="btn btn-default" onClick={clickProjectListBtn}>
                            <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                            Back to List
                        </button>
                    </div>
                    {loading ? <CustomLoader /> :
                        <div style={containerStyle}>
                            <h3 className="title-style01">Modify Project Registration</h3>
                            <ProjectForm id={id} />
                        </div>
                    }
                </section>
            </div>
            <ScrollTop />
        </>
    );
}
